<template>
  <div class="main">
    <reportTop></reportTop>
    <selectTool ref="selectTool">
      <template slot="btn">
        <Button @click="openAdd" type="primary" class="chaxun">新增</Button><Button @click="getSearchItem"
          class="chaxun">查询</Button>
        <Button @click="daoru" class="chaxun">导入</Button>
        <Button @click="exportAll" class="chaxun">导出</Button></template>
    </selectTool>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)">
      <template slot-scope="{ row, index }" slot="proofList">
        <viewer v-if="row.proofList.length > 0">
          <img v-for="(x, index) in row.proofList" :key="index" :src="axios.platConfig.fileUri + x" width="24"
            height="24" style="margin-right: 4px; cursor: pointer" />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
      <template slot-scope="{ row, index }" slot="liuchengstatus">
        <Button v-if="row.flowStartId == null" type="error" size="small" @click="addFlow(row)">重新流程</Button>
        <span v-else>已发起</span>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <form-model :title="isAdd ? '新增记录' : '编辑记录'" width="700" ref="formModel">
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <daoru ref="daoru" @finesh="getList"></daoru>
    <createdFlow ref="createdFlow" @ok="getList"></createdFlow>
  </div>
</template>
<script>

import createdFlow from "../diaodu/forms/createdFlow.vue";
import fields from "../diaodu/forms/fields";
export default {
  props: ['data'],
  components: { createdFlow },
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "流水号",
          key: "no",
          sort: 1,
        },
        {
          title: "单位名称",
          key: "groupName",
          sort: 2,
        },
        {
          title: "流程状态",
          slot: "liuchengstatus",
          sort: 2,
        },
        {
          title: "创建者账号",
          key: "createAccount",
          sort: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          sort: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {},

      total: 0,
      forms: [],
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
        startTime: 0,
        endTime: 0,
        carIdList: [],
        status: 3, //statue：1-审核，2-撤销。3-通过，
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          type: "lyyymmdd",
          times: "2,0,4",
        },
        {
          title: "选择车辆",
          carIdList: "carIdList",
          type: "selectAlotCar",
          times: "2,0,4",
        },
      ],
      imp: {},
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.cost + this.data.urlKey + "/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;

        var data = res.data.data.dataList;
        this.chuli(data);


      });
    },
    chuli(data) {
      var t = this.data.formId;
      if (t == 'baoyang') {
        for (let i = 0; i < data.length; i++) {
          data[i].careDate2 = this.utils.time(data[i].careDate, "yymmdd");
        }
      }
      if (t == 'jiayou') {
        for (let i = 0; i < data.length; i++) {
          data[i].refuelDate2 = this.utils.time(data[i].refuelDate, "yymmdd");
        }
      }
      if (t == 'baoxian') {
        for (let i = 0; i < data.length; i++) {
          data[i].insurDate2 = this.utils.time(data[i].insurDate, "yymmdd");
          data[i].expireDate2 = this.utils.time(data[i].expireDate, "yymmdd");
        }
      }
      if (t == 'weizhang') {
        for (let i = 0; i < data.length; i++) {
          data[i].peccancyDate2 = this.utils.time(data[i].peccancyDate2, "yymmdd");
        }
      }
      this.tableData = data;
      console.log(data);
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.cost + this.data.urlKey + "/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.addFlow(res.data.data);
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.cost + this.data.urlKey + "/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    addFlow(data) {
      console.log(6666, data);
      var obj = {
        no: data.no,
        id: data.id, //文档id
        groupId: data.groupId,
        formId: this.data.formId, //模板id,
        filler: this.data.urlKey
        //模板id
      };
      this.$refs.createdFlow.reach(obj);
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.cost + this.data.urlKey + "/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    exportAll() {
      var params = [
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
        {
          name: "carIdList",
          value: this.searchItem.carIdList,
        },
      ];
      this.utils.exportData(this.axios.cost + this.data.urlKey + "/export", params);
    },
    daoru() {
      this.$refs.daoru.reach(this.imp);
    },
    now(v) {
      this.searchItem.status = v;
      this.getList();
    }
  },
  mounted() {
    this.forms = fields[this.data.formId];
    this.item = this.data.item;
    this.imp = {
      temUrl: this.axios.ipPort + "/cloud-common-server-cost/" + this.data.urlKey + "/tmpl",
      url: this.axios.ipPort + "/cloud-common-server-cost/" + this.data.urlKey + "/imp",
    }
    var config = {
      min: 150,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    console.log(this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/pay/commona.vue